module.exports = __webpack_public_path__ + "img/PC_header_hoken.253f58b2.png";